import Content from "./Content";


function Tnc() {
    return (
        <>
            <div>
                <Content />
            </div>
        </>
    );
}

export default Tnc;
